  
import React from 'react';
import './Form.css';

const FormSuccess = () => {
  return (
    <div>
      <img src="form-submitted.jpg" alt="form-submitted"></img>
    </div>
  );
};

export default FormSuccess;